module.exports = __webpack_public_path__ + "img/logo.780f1972.svg";